export const getShapeTypeFromRubric = (rubric) => {
    return rubric?.presetShapeType ?? rubric?.presetAttributeForShape?.shapeType;
};

export const getShapeTypeFromAnnotation = (annotation) => {
    return annotation?.roadData.shapeType;
};
